import { Dices } from 'lucide-react';

// 2026-06 — full-screen blocking overlay while Draft Random runs so the
// user can't navigate mid-mutation and desync the roster UI.
export const DraftingOverlay = ({ visible }) => {
  if (!visible) return null;
  return (
    <div
      className="fixed inset-0 z-[200] bg-background/80 backdrop-blur-sm flex flex-col items-center justify-center gap-3"
      data-testid="draft-random-overlay"
    >
      <Dices className="h-10 w-10 animate-spin text-primary" />
      <p className="text-sm font-semibold">Drafting your team…</p>
      <p className="text-xs text-muted-foreground">Picking a smart-random mix for your open slots</p>
    </div>
  );
};

export default DraftingOverlay;
